export default {
  fadedBgColor() {
    return '#ebebeb';
  }
};
